<template>
  <same-as :reference="reference"/>
</template>

<script>
import SameAs from './electoral_roll_multiple_spd.vue'

export default {
  components: { SameAs },
  props: ['reference']
}
</script>
